var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4Contact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 52,
    viewBox: "0 0 61 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6827 26.2032C44.6828 23.4339 43.8617 20.7267 42.3232 18.424C40.7846 16.1214 38.5978 14.3267 36.0392 13.2669C33.4807 12.2072 30.6653 11.9299 27.9492 12.4703C25.2331 13.0107 22.7382 14.3444 20.7801 16.3027C18.822 18.261 17.4886 20.7561 16.9485 23.4723C16.4085 26.1884 16.686 29.0038 17.7461 31.5622C18.8061 34.1206 20.6011 36.3073 22.9039 37.8455C25.2067 39.3838 27.914 40.2046 30.6834 40.2042C34.3966 40.2042 37.9578 38.7291 40.5835 36.1034C43.2092 33.4777 44.6843 29.9165 44.6843 26.2032",
    fill: "#00D8AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6827 26.2032C44.6828 23.4339 43.8617 20.7267 42.3232 18.424C40.7846 16.1214 38.5978 14.3267 36.0392 13.2669C33.4807 12.2072 30.6653 11.9299 27.9492 12.4703C25.2331 13.0107 22.7382 14.3444 20.7801 16.3027C18.822 18.261 17.4886 20.7561 16.9485 23.4723C16.4085 26.1884 16.686 29.0038 17.7461 31.5622C18.8061 34.1206 20.6011 36.3073 22.9039 37.8455C25.2067 39.3838 27.914 40.2046 30.6834 40.2042C34.3964 40.2038 37.9572 38.7285 40.5825 36.1029C43.2079 33.4772 44.6827 29.9163 44.6827 26.2032Z",
    stroke: "#00D8AE",
    strokeWidth: 0.535227,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1922 13.3256C32.2457 12.2945 29.0345 12.3059 26.0953 13.3579C23.1562 14.4099 20.6671 16.4388 19.0441 19.1054C17.421 21.7721 16.7623 24.915 17.1781 28.009C17.5939 31.1029 19.0589 33.9604 21.3283 36.104C23.5978 38.2476 26.5342 39.5474 29.6468 39.7861C32.7594 40.0249 35.8597 39.1881 38.4295 37.4157C40.9993 35.6434 42.883 33.0427 43.7658 30.0483C44.6485 27.054 44.4769 23.8474 43.2795 20.9644",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6797 26.2031L41.1562 15.7266",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6799 26.2036L24.3203 21.082",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6192 26.2031C32.6192 25.8199 32.5055 25.4453 32.2927 25.1267C32.0798 24.8081 31.7772 24.5598 31.4231 24.4131C31.0691 24.2665 30.6795 24.2281 30.3037 24.3029C29.9278 24.3776 29.5826 24.5621 29.3116 24.8331C29.0407 25.1041 28.8561 25.4493 28.7814 25.8252C28.7066 26.201 28.745 26.5906 28.8916 26.9446C29.0383 27.2986 29.2866 27.6012 29.6052 27.8141C29.9239 28.027 30.2985 28.1407 30.6817 28.1407C31.1955 28.1407 31.6883 27.9365 32.0517 27.5732C32.4151 27.2098 32.6192 26.717 32.6192 26.2031Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.304 23.1797L5.69091 26.5452L1.10938 23.2268",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70703 26.2021C5.70803 20.2857 7.79403 14.5589 11.5985 10.0279C15.403 5.49689 20.6825 2.45158 26.5096 1.42704C32.3366 0.40249 38.3383 1.46424 43.4601 4.42574C48.582 7.38724 52.4963 12.059 54.5154 17.6202",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0586 29.2268L55.6717 25.8613L60.2533 29.1797",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6541 26.2031C55.6531 32.1195 53.5671 37.8463 49.7626 42.3773C45.9581 46.9083 40.6786 49.9536 34.8516 50.9782C29.0245 52.0027 23.0228 50.941 17.901 47.9795C12.7791 45.018 8.86478 40.3462 6.8457 34.7849",
    stroke: "black",
    strokeWidth: 1.07045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4Contact);
export default __webpack_public_path__ + "static/media/icon4contact.058efbe37960eb6710f4b9e63593d9d8.svg";
export { ForwardRef as ReactComponent };